import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, MultiSelect } from '@Components/Filters';

import { FilterForm } from './types';
import { languageLabels } from '../languages';
import {
  getSalaryCertTypeLabels,
  getStatusLabels,
} from '../store/selectors/salaryCertificateSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError }) => {
  const salaryCertTypes = useAppSelector(getSalaryCertTypeLabels);
  const statuses = useAppSelector(getStatusLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'PURPOSE',
      label: 'Purpose (Reason)',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="purpose"
          options={salaryCertTypes}
        />
      ),
    },
    {
      id: 'REQUIRED LANGUAGE',
      label: 'Required Language',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="requiredLanguage"
          options={languageLabels}
        />
      ),
    },
    {
      id: 'REQUIRED BY DATE RANGE',
      label: 'Required By Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
